/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { ForceAsEnum } from "./ForceAsEnum";
import {
  ForceAsEnumFromJSON,
  ForceAsEnumFromJSONTyped,
  ForceAsEnumToJSON,
  ForceAsEnumToJSONTyped,
} from "./ForceAsEnum";

/**
 *
 * @export
 * @interface Commit
 */
export interface Commit {
  /**
   *
   */
  commitMessage?: string | null;
  /**
   *
   */
  forceAs?: ForceAsEnum;
  /**
   *
   */
  schematisationName?: string;
  /**
   * The datetime of the commit (only superusers can modify)
   */
  commitDate?: Date | null;
  /**
   * The user that committed the revision (only superusers can modify)
   */
  commitUser?: string;
  /**
   * User that committed the revision on models.lizard.net (only superusers can modify)
   */
  user?: string | null;
  /**
   * tags provided as a list of strings
   */
  tags?: Array<string>;
}

/**
 * Check if a given object implements the Commit interface.
 */
export function instanceOfCommit(value: object): value is Commit {
  return true;
}

export function CommitFromJSON(json: any): Commit {
  return CommitFromJSONTyped(json, false);
}

export function CommitFromJSONTyped(json: any, ignoreDiscriminator: boolean): Commit {
  if (json == null) {
    return json;
  }
  return {
    commitMessage:
      json["commit_message"] === undefined
        ? undefined
        : json["commit_message"] === null
        ? null
        : json["commit_message"],
    forceAs: json["force_as"] == null ? undefined : ForceAsEnumFromJSON(json["force_as"]),
    schematisationName:
      json["schematisation_name"] == null ? undefined : json["schematisation_name"],
    commitDate:
      json["commit_date"] === undefined
        ? undefined
        : json["commit_date"] === null
        ? null
        : parseDateTime(json["commit_date"]),
    commitUser: json["commit_user"] == null ? undefined : json["commit_user"],
    user: json["user"] === undefined ? undefined : json["user"] === null ? null : json["user"],
    tags: json["tags"] == null ? undefined : json["tags"],
  };
}

export function CommitToJSON(json: any): Commit {
  return CommitToJSONTyped(json, false);
}

export function CommitToJSONTyped(
  value?: Commit | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    commit_message: value["commitMessage"],
    force_as: ForceAsEnumToJSON(value["forceAs"]),
    schematisation_name: value["schematisationName"],
    commit_date:
      value["commitDate"] == null ? value["commitDate"] : serializeDateTime(value["commitDate"]),
    commit_user: value["commitUser"],
    user: value["user"],
    tags: value["tags"],
  };
}
